module.exports = __webpack_public_path__ + "static/media/MentorGreame.851ebb85.jpeg";